import { useSelector } from 'react-redux';

const DEFAULT_MAX = 50;

/**
 * Same effective page-size logic as `Table` (`sharedPageSize` + `sharedListPageSize`), or
 * if `sharedPageSize` is false, only the `tableId` table state.
 * Uses as many skeleton rows as the table will show (capped) to limit height jump on reload.
 *
 * @param {string|undefined|null} tableId
 * @param {object} [options]
 * @param {boolean} [options.sharedPageSize=true] same as `Table`’s `sharedPageSize` prop
 * @param {number} [options.fallback=10]
 * @param {number} [options.maxRows=50]
 * @returns {number}
 */
export function useListTableSkeletonRowCount(
    tableId,
    { sharedPageSize = true, fallback = 10, maxRows = DEFAULT_MAX } = {}
) {
    return useSelector((state) => {
        if (!tableId) return fallback;
        const tables = state.tables;
        const own = tables?.[tableId]?.pageSize;
        if (!sharedPageSize) {
            return Math.min(Math.max(Number(own) || fallback, 1), maxRows);
        }
        const shared = tables?.sharedListPageSize;
        const ps = shared ?? own ?? fallback;
        return Math.min(Math.max(Number(ps) || fallback, 1), maxRows);
    });
}
